import { render, staticRenderFns } from "./PaddleCheckout.vue?vue&type=template&id=28236491&"
import script from "./PaddleCheckout.vue?vue&type=script&lang=js&"
export * from "./PaddleCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports